import Swal from "sweetalert2";

export function errorHandler(err) {
  // Callers pass either an Axios error or its response directly.
  const response = err?.response || (err?.status ? err : undefined);
  const status = response?.status;
  const data = response?.data;
  const message = [
    data?.message,
    data?.data?.message,
    data?.data?.keterangan,
  ].find((value) => typeof value === "string" && value.trim());

  if (status === 401 || status === 403) {
    return Swal.fire({
      icon: "error",
      title: "Oops...",
      text: message || "Sesi Anda telah berakhir. Silakan login kembali.",
    }).then(() => {
      localStorage.removeItem("token");
      window.location.replace("/auth/login-page");
    });
  }

  if (status === 503) {
    localStorage.removeItem("token");
    window.location.replace("/auth/pemeliharaan");
    return;
  }

  return Swal.fire({
    icon: "error",
    title: "Oops...",
    text: response
      ? message || "Terjadi kesalahan pada server. Silakan coba lagi."
      : "Periksa koneksi internet anda!",
  });
}
